<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Vendor accounts</h1>
      <p class="text-gray-600 text-sm">Invite vendors, suspend availability without disabling login, and offboard when projects complete.</p>
    </div>
    <button
      type="button"
      (click)="goAdd()"
      class="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700"
    >
      Add / invite vendor
    </button>
  </div>

  <div class="bg-white rounded-xl shadow border border-gray-200 overflow-hidden">
    <div *ngIf="loading" class="p-8 text-center text-gray-500">Loading…</div>
    <table *ngIf="!loading" class="min-w-full text-sm">
      <thead class="bg-gray-50 text-left text-gray-600">
        <tr>
          <th class="px-4 py-3 font-semibold">Code</th>
          <th class="px-4 py-3 font-semibold">Company</th>
          <th class="px-4 py-3 font-semibold">Contact</th>
          <th class="px-4 py-3 font-semibold">Host org</th>
          <th class="px-4 py-3 font-semibold">Status</th>
          <th class="px-4 py-3 font-semibold text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows" class="border-t border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 font-mono">{{ r.vendor_code }}</td>
          <td class="px-4 py-3">{{ r.company_name }}</td>
          <td class="px-4 py-3">{{ r.primary_contact_email }}</td>
          <td class="px-4 py-3">{{ r.host_org_name || '—' }}</td>
          <td class="px-4 py-3">
            <span class="px-2 py-1 rounded-full text-xs font-medium capitalize" [ngClass]="getStatusClass(r)">
              {{ getStatusLabel(r) }}
            </span>
          </td>
          <td class="px-4 py-3 text-right">
            <div class="inline-flex items-center gap-1">
              <button
                *ngIf="!isOffboarded(r) && !isSuspended(r)"
                type="button"
                mat-icon-button
                matTooltip="Suspend availability (login stays active)"
                [disabled]="isActionPending(r)"
                (click)="suspendVendor(r)"
              >
                <mat-icon>pause_circle</mat-icon>
              </button>
              <button
                *ngIf="isSuspended(r)"
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Restore availability"
                [disabled]="isActionPending(r)"
                (click)="unsuspendVendor(r)"
              >
                <mat-icon>play_circle</mat-icon>
              </button>
              <button
                *ngIf="!isOffboarded(r)"
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Offboard vendor"
                [disabled]="isActionPending(r)"
                (click)="offboardVendor(r)"
              >
                <mat-icon>person_off</mat-icon>
              </button>
              <button
                *ngIf="isOffboarded(r)"
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Reinstate vendor"
                [disabled]="isActionPending(r)"
                (click)="reinstateVendor(r)"
              >
                <mat-icon>person_add</mat-icon>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="rows.length === 0">
          <td colspan="6" class="px-4 py-8 text-center text-gray-500">No vendors yet.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
